import { useEffect } from 'react'

const useCargarPresupuesto = (
  presupuesto,
  setPresupuestoId,
  setCliente,
  reset,
  agregarItemManualmente,
  history
) => {
  useEffect(() => {
    if (presupuesto && presupuesto.id) {
      // Establecer el presupuestoId
      setPresupuestoId(presupuesto.id)

      // Cargo el cliente del presupuesto si existe
      if (presupuesto.cliente) {
        setCliente(presupuesto.cliente)
      }

      // Limpio los articulos anteriores
      reset()

      // Agrego los items del presupuesto a la tabla
      presupuesto.items.forEach((item, index) => {
        const articuloVenta = {
          articulo: item.articulo,
          cantidad: item.cantidad || 1,
          precio: item.precio || 0,
          total: item.precio,
          id: item.articulo.id,
          porcentajeIva: item.articulo.porcentajeIva || 21,
          descuento: item.descuento || 0,
          iva: item.articulo.porcentajeIva || 21,
          index: index,
          fromPresupuesto: true
        }

        agregarItemManualmente(articuloVenta)
      })

      // Limpio el state para evitar la persistencia al actualizar
      history.replace()
    }
  }, [presupuesto?.id, setPresupuestoId, setCliente, reset, agregarItemManualmente, history])
}

export default useCargarPresupuesto